import { createStorage } from '../cache/index';

const { get, set, remove } = createStorage();
export function setAIChecked(value: boolean) {
  set('AI-checked', value);
}
export function getAIChecked(): boolean {
  return get('AI-checked');
}
export function deleteAIChecked() {
  remove('AI-checked');
}

export function setAIMonitorModal(value: boolean) {
  set('AI-MonitorModal', value);
}
export function getAIMonitorModal(): boolean {
  return get('AI-MonitorModal');
}
export function deleteAIMonitorModal() {
  remove('AI-MonitorModal');
}
export function setPrivacyModal(value: boolean) {
  set('Privacy-Modal', value);
}
export function getPrivacyModal(): boolean {
  return get('Privacy-Modal');
}
export function deletePrivacyModal() {
  remove('Privacy-Modal');
}
export function setRefreshNum(value: number) {
  set('Refresh-Num', value);
}
export function getRefreshNum(): number {
  return get('Refresh-Num');
}
export function deleteRefreshNum() {
  remove('Refresh-Num');
}
// 是否弹出过提示框
export function setStatementRecord(data: boolean) {
  set('statement-record', data);
}
export function getStatementRecord(): boolean {
  return get('statement-record');
}
export function deleteStatementRecord() {
  remove('statement-record');
}
